import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSharkfin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#TwoColorSharkfin_svg__a)">
      <path
        fill={getTheme(props["data-theme"])}
        d="M13.328 7.684c-3.304 2.284-7.324 6.522-9.836 12.538a.75.75 0 0 1-1.384-.578c2.63-6.3 6.844-10.758 10.367-13.194 1.747-1.208 3.388-1.963 4.625-2.152.602-.093 1.254-.073 1.76.26.583.384.755 1.026.669 1.667-.343 2.553-.515 5.642-.515 8.255 0 1.306.043 2.48.127 3.402.042.46.094.848.152 1.15.062.32.122.488.155.55a.75.75 0 0 1-1.326.702c-.14-.266-.233-.613-.301-.966-.072-.37-.129-.81-.174-1.3-.09-.982-.133-2.205-.133-3.538 0-2.667.175-5.824.528-8.454a.477.477 0 0 0-.007-.215c-.042-.027-.236-.103-.708-.03-.912.139-2.333.75-4 1.903Z"
      />
      <path
        fill="#F7A600"
        d="M13.438 20.117c-.375.41-.983 1.072-2.105 1.072-.503 0-.912-.084-1.258-.273-.341-.186-.551-.44-.689-.607l-.012-.014c-.139-.169-.217-.263-.34-.353-.115-.085-.305-.187-.662-.262-.551-.115-.949.078-1.543.531-.086.066-.177.139-.275.216-.529.422-1.229.98-2.13 1.231-1.035.29-2.016-.152-2.72-.641a7.215 7.215 0 0 1-1.648-1.634.75.75 0 0 1 1.22-.873c.259.362.734.892 1.286 1.276.571.398 1.07.536 1.458.428.584-.163 1.011-.5 1.54-.915.114-.09.233-.184.36-.28.668-.511 1.534-1.064 2.76-.807.532.112.927.29 1.241.52.28.205.468.435.592.586l.03.037c.132.16.185.209.25.244.06.033.201.09.54.09.45 0 .635-.199 1.049-.64l.054-.057c.207-.22.505-.526.927-.71.453-.197.961-.22 1.54-.058 1.021.286 1.755.851 2.306 1.276l.044.034c.619.476.901.652 1.191.652.148 0 .358-.049.636-.174a6 6 0 0 0 .87-.505c.302-.205.596-.427.876-.638l.02-.016c.262-.197.53-.4.754-.541a.75.75 0 0 1 .8 1.27c-.165.103-.382.266-.67.484l-.006.004c-.275.207-.596.45-.933.679-.338.23-.712.457-1.094.63-.376.17-.808.307-1.253.307-.858 0-1.537-.524-2.042-.915l-.064-.049c-.575-.442-1.108-.849-1.838-1.053-.31-.087-.456-.047-.538-.012-.114.05-.231.148-.433.363l-.09.097ZM20.643 1l.043.38c.115 1.017.976 1.831 2.073 1.961-1.113.193-1.952 1.04-2.064 2.083l-.052.49-.05-.497c-.1-1.034-.936-1.884-2.04-2.076 1.095-.13 1.944-.94 2.05-1.958l.04-.383Z"
      />
    </g>
    <defs>
      <clipPath id="TwoColorSharkfin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTwoColorSharkfin;
